import tippy from "tippy.js";
import ShareButtons from "../social/ShareButtons";

let getDisableOnMobile = ($tooltip) => $tooltip.attr("data-tooltip-disable-on-mobile") || false;

let initHtmlTooltip =  () => {
    $("[data-tooltip-for]").each(function () {
        let reference = $(this),
            tooltipFor = $(this).attr("data-tooltip-for"),
            tooltipPlacement = $(this).attr("data-tooltip-placement"),
            tooltip = $("#" + tooltipFor);

        tooltipPlacement = tooltipPlacement ? tooltipPlacement : "auto";

        if (reference.length <= 0)
            return;

        tooltip.addClass("tooltip-for--visible");
        let template = tooltip.get(0).outerHTML;
        tooltip.remove();
        tippy(reference[0], {
            content: `<div>${template}</div>`,
            placement: tooltipPlacement,
            allowHTML: true,
            trigger: "click",
            interactive: true,
            appendTo: document.body,
            touch: getDisableOnMobile(reference),
            onShow(instance) {
                setTimeout(() => {
                    ShareButtons.init("quote");
                }, 500);
            },

        });
    });
}

export default {
    initHtmlTooltip: initHtmlTooltip
}



// WEBPACK FOOTER //
// ./js/tooltip/Tooltip.js